module.exports = __webpack_public_path__ + "static/img/news_22.dc99c62.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/news/news_22.jpg
// module id = rdeG
// module chunks = 2